export const mascaraCep = () => {
  return "00000-000";
};

export const mascaraTelefoneFixo = () => {
  return "(00) 0000-0000";
};

export const mascaraCelular = () => {
  return "(00) 00000-0000";
};

export const mascaraCpfInput = () => {
  return "000.000.000-00";
};

export const mascaraCnpjInput = () => {
  return "00.000.000/0000-00";
};

export const mascaraData = () => {
  return "00/00/0000";
};
